import React from "react";
import { createRoot } from "react-dom/client";
import ChangeRegisterIsland from "./ChangeRegisterIsland";

const mountNode = document.getElementById("change-register-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<ChangeRegisterIsland config={config} />);
  }
}
